import { combineReducers } from "redux";
import { ScopeLoadingState } from "./scope-loading/types";
import { ScopeErrorState } from "./scope-error/types";
import { scopeLoadingReducer } from "./scope-loading/reducer";
import { scopeErrorReducer } from "./scope-error/reducer";
import { UserState } from "./user/types";
import { userReducer } from "./user/reducer";
import { contactServiceReducer } from "./contact-service/reducer";
import { ContactServiceState } from "./contact-service/types";
import { cancellationServiceReducer } from "./cancellation-service/reducer";
import { CancellationServiceState } from "./cancellation-service/types";
import { AceClaimState } from "./ace-claim/types";
import { aceClaimReducer } from "./ace-claim/reducer";
import { Ace2ClaimState } from "./ace2-claim/types";
import { ace2ClaimReducer } from "./ace2-claim/reducer";
import { ace2WarrntyItemReducer } from "./add-ace2-warrnty-item/reducer";
import { Ace2WarrntyItemState } from "./add-ace2-warrnty-item/types";

export interface RootState {
  scopeLoading: ScopeLoadingState;
  scopeError: ScopeErrorState;
  user: UserState;
  contactService: ContactServiceState;
  cancellationService: CancellationServiceState;
  aceClaim: AceClaimState;
  ace2Claim: Ace2ClaimState;
  ace2WarrntyItem: Ace2WarrntyItemState;
}

const createRootReducer = () =>
  combineReducers({
    user: userReducer,
    scopeLoading: scopeLoadingReducer,
    scopeError: scopeErrorReducer,
    contactService: contactServiceReducer,
    cancellationService: cancellationServiceReducer,
    aceClaim: aceClaimReducer,
    ace2Claim: ace2ClaimReducer,
    ace2WarrntyItem: ace2WarrntyItemReducer,
  });

export default createRootReducer;
